import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatErr } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Gift, Ticket } from "lucide-react";
import { toast } from "sonner";

export default function Redeem() {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!user) { navigate("/login"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/licenses/redeem", { code: code.trim() });
      toast.success(data.message);
      navigate(`/tests/${data.test.slug}/take`);
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-5rem)] lumina-bg-soft flex items-center justify-center py-16" data-testid="redeem-page">
      <div className="lumina-card w-full max-w-md p-10">
        <div className="w-14 h-14 rounded-2xl bg-[#E8F0FA] flex items-center justify-center mb-5">
          <Gift className="w-6 h-6 text-[#6B4BA3]" />
        </div>
        <div className="lumina-label mb-2">Redeem</div>
        <h1 className="font-serif text-4xl text-[#1A1728] mb-3">Klaim Kode Lisensi</h1>
        <p className="text-sm text-[#5C5870] mb-6">Dapatkan akses tes psikologi gratis lewat kode yang diberikan perusahaan/instansi Anda.</p>
        <form onSubmit={submit} className="space-y-4">
          <div className="relative">
            <Ticket className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-[#6B4BA3]" />
            <input
              required value={code}
              onChange={e => setCode(e.target.value.toUpperCase())}
              placeholder="HI-XXXX-XXXXXXXX"
              className="w-full pl-11 pr-4 py-3 rounded-xl border border-[#E2DFED] focus:border-[#6B4BA3] outline-none font-mono uppercase tracking-wider"
              data-testid="redeem-code-input"
            />
          </div>
          <button disabled={loading} className="lumina-btn-primary w-full" data-testid="redeem-submit">
            {loading ? "Memproses…" : "Klaim Akses"}
          </button>
        </form>
      </div>
    </div>
  );
}
